module.exports = __webpack_public_path__ + "static/media/bfile-homeowners.625e79a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-homeowners.svg
// module id = 258
// module chunks = 0